export default (str: string, timeout: number = 3000, type: string = 'success'): HTMLElement => {
  const toast = document.createElement('div');
  toast.className = `toast toast--${type}`;
  toast.innerHTML = str;
  document.body.appendChild(toast);

  if (timeout > 0) {
    setTimeout(() => {
      toast.parentNode.removeChild(toast);
    }, timeout);
  }

  return toast;
};
